import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import { AdministrativeRecord } from '../../types/evolution.types';

interface AdministrativeRecordStatusProps {
  record?: AdministrativeRecord | null;
}

const moneyFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  minimumFractionDigits: 2,
});

const dateFormatter = new Intl.DateTimeFormat('es-AR', {
  dateStyle: 'short',
  timeStyle: 'short',
});

const formatDate = (value: string | null): string => {
  if (!value) return 'Sin fecha';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : dateFormatter.format(date);
};

const tooltipText = (record?: AdministrativeRecord | null): string => {
  if (!record?.associated || !record.associations?.length) {
    return 'No existe registro administrativo asociado';
  }
  return record.associations.map((association) => {
    const operation = association.operationId == null
      ? `Orden #${association.orderId}`
      : `Operación #${association.operationId} · Orden #${association.orderId}`;
    return `${operation}\nAsociada: ${formatDate(association.associatedAt)} · Monto: ${moneyFormatter.format(association.amount ?? 0)}`;
  }).join('\n\n');
};

// Va en el pie de la evolución (nv-scope); sus estilos viven en MedicalEvolutionModal.scss.
export default function AdministrativeRecordStatus({ record }: AdministrativeRecordStatusProps) {
  const associated = Boolean(record?.associated && record.associations?.length);
  const description = tooltipText(record);

  return (
    <>
      <Tooltip className="nv-tooltip evo-administrative-tooltip" target=".evo-administrative-status" position="top" event="both" />
      <Tag
        className={`evo-administrative-status ${associated ? 'nv-tag-ok' : 'nv-tag-warn'}`}
        icon="pi pi-dollar"
        value={associated ? 'Registro administrativo' : 'Sin registro administrativo'}
        data-pr-tooltip={description}
        data-pr-position="top"
        tabIndex={0}
        role="status"
        aria-label={associated ? `Registro administrativo asociado. ${description}` : description}
      />
    </>
  );
}
